module.exports = __webpack_public_path__ + "static/media/students-1.e24e0e43.png";